import React from 'react';
import { PatientAddModalTemplate } from 'themes/application/facility-order/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { PatientAddModalViewStore } from 'application/facility-order/stores';

@setCurrentView((rootStore, componentProps) => new PatientAddModalViewStore(rootStore, componentProps), 'patientAddModalViewStore')
@observer
class PatientAddModal extends React.Component {
    render() {
        return <PatientAddModalTemplate {...this.props} />
    }
}

export default PatientAddModal;